import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const DesktopSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 46 46' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      opacity='0.5'
      d='M32.3301 1.21047C34.4357 0.541944 36.4027 1.77187 36.7236 3.95757L39.0346 19.6978C40.2381 27.8942 34.8128 36.571 26.9169 39.078L21.5028 40.797C12.4524 43.6705 3.99734 38.3839 2.61796 28.989L1.64242 22.3446C0.759923 16.3339 4.73847 9.97092 10.5288 8.13248L32.3301 1.21047Z'
      fill='url(#paint0_linear_2692_205062)'
    />
    <g clipPath='url(#clip0_2692_205062)'>
      <path
        d='M39.4287 9.56592H17.0511C15.5063 9.56592 14.2539 10.8183 14.2539 12.3631V26.3491C14.2539 27.8939 15.5063 29.1463 17.0511 29.1463H39.4287C40.9735 29.1463 42.2259 27.8939 42.2259 26.3491V12.3631C42.2259 10.8183 40.9735 9.56592 39.4287 9.56592Z'
        stroke='#2C3B38'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22.6465 34.7407H33.8353'
        stroke='#2C3B38'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M28.2402 29.1465V34.7409'
        stroke='#2C3B38'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_2692_205062'
        x1='22.9614'
        y1='-0.490701'
        x2='42.2451'
        y2='17.4914'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#D58405' />
        <stop offset='0.396113' stopColor='#F39C12' />
        <stop offset='1' stopColor='#EEB457' />
      </linearGradient>
      <clipPath id='clip0_2692_205062'>
        <rect width='33.5664' height='33.5664' fill='white' transform='translate(11.457 5.37012)' />
      </clipPath>
    </defs>
  </svg>
);

export const DesktopIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DesktopSvg} {...props} />
);
